import React from 'react'
import { ControlLabel } from '../label/Label'
import InputTextareaComp from '../inputs/InputTextarea'
import './labeledInput.scss'

const LabeledTextarea = ({
  classNameBox,
  idLabel,
  required,
  name,
  value,
  disabled,
  onChange,
  ...propsPassword
}) => {
  return (
    <div className={`flex-container ${classNameBox}`}>
      <ControlLabel id={idLabel} required={required} />
      <div className="control-input">
        <InputTextareaComp
          name={name}
          value={value}
          disabled={disabled}
          onChange={onChange}
          {...propsPassword}
        />
      </div>
    </div>
  )
}

export default LabeledTextarea
